import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { Alert } from '@keboola/design';
import { Boxes, Building2, CircleUser, Users } from '@keboola/design/icons';

import { session } from '../api';
import { useAuth } from '../auth/context';
import { DashboardChrome, type DashboardNavItem } from '../components/DashboardChrome';

const NAV: readonly DashboardNavItem[] = [
  { to: '/admin', label: 'Components', icon: Boxes },
  { to: '/admin/developers', label: 'Developers', icon: Users },
  { to: '/admin/vendors', label: 'Vendors', icon: Building2 },
  { to: '/admin/profile', label: 'Profile', icon: CircleUser },
];

export const Route = createFileRoute('/admin')({
  // Signed-in check only; a non-admin gets an explicit refusal in `AdminLayout`, not a redirect.
  beforeLoad: ({ location }) => {
    if (session.get() === null) {
      throw redirect({ to: '/auth/login', search: { redirect: location.href } });
    }
  },
  component: AdminLayout,
});

function AdminLayout() {
  const { identity } = useAuth();

  if (identity?.isAdmin !== true) {
    return (
      <DashboardChrome section="admin" nav={[]}>
        <Alert variant="error" title="Administrator access required">
          This section is limited to Keboola staff. If you believe you should have access, contact
          Keboola support.
        </Alert>
      </DashboardChrome>
    );
  }

  return (
    <DashboardChrome section="admin" nav={NAV}>
      <Outlet />
    </DashboardChrome>
  );
}
